import {library, dom} from '@fortawesome/fontawesome-svg-core'
import {faExpandAlt} from '@fortawesome/pro-solid-svg-icons/faExpandAlt'
import {faCompressAlt} from '@fortawesome/pro-solid-svg-icons/faCompressAlt'
import {faQuestionCircle} from '@fortawesome/pro-solid-svg-icons/faQuestionCircle'
import {faCog} from '@fortawesome/pro-solid-svg-icons/faCog'
import {faAngleLeft} from '@fortawesome/pro-solid-svg-icons/faAngleLeft'
import {faAngleRight} from '@fortawesome/pro-solid-svg-icons/faAngleRight'
import {faThLarge} from '@fortawesome/free-solid-svg-icons/faThLarge'
import {faUser} from '@fortawesome/free-solid-svg-icons/faUser'
import {faFile} from '@fortawesome/pro-regular-svg-icons/faFile'
import {faProjectDiagram} from '@fortawesome/free-solid-svg-icons/faProjectDiagram'
import {faCopy} from '@fortawesome/pro-regular-svg-icons/faCopy'
import {faPlus} from '@fortawesome/pro-solid-svg-icons/faPlus'
import {faPencilAlt} from '@fortawesome/pro-regular-svg-icons/faPencilAlt'
import {faTrashAlt} from '@fortawesome/pro-regular-svg-icons/faTrashAlt'
import {faCode} from '@fortawesome/pro-regular-svg-icons/faCode'
import {faVideo} from '@fortawesome/pro-regular-svg-icons/faVideo'
import {faCalendarAlt} from '@fortawesome/pro-regular-svg-icons/faCalendarAlt'
import {faPalette} from '@fortawesome/pro-regular-svg-icons/faPalette'
import {faSearch} from '@fortawesome/pro-regular-svg-icons/faSearch'
import {faTimes} from '@fortawesome/pro-light-svg-icons/faTimes'
import {faTimes as faTimesSolid} from '@fortawesome/free-solid-svg-icons/faTimes'
import {faCheck} from '@fortawesome/free-solid-svg-icons/faCheck'
import {faSort} from '@fortawesome/free-solid-svg-icons/faSort'
import {faBars} from '@fortawesome/free-solid-svg-icons/faBars'
import {faStar} from '@fortawesome/free-solid-svg-icons/faStar'
import {faSortDown} from '@fortawesome/free-solid-svg-icons/faSortDown'
import {faSortUp} from '@fortawesome/free-solid-svg-icons/faSortUp'
import {faImage} from '@fortawesome/free-solid-svg-icons/faImage'
import {faEye} from '@fortawesome/free-solid-svg-icons/faEye'
import {faBell} from '@fortawesome/free-solid-svg-icons/faBell'
import {faArrowToBottom} from '@fortawesome/pro-regular-svg-icons/faArrowToBottom'
import {faArrowLeft} from '@fortawesome/pro-regular-svg-icons/faArrowLeft'
import {faArrowRight} from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import {faArrowRight as fasArrowRight} from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import {faEnvelope} from '@fortawesome/free-solid-svg-icons/faEnvelope'
import {faMobile} from '@fortawesome/free-solid-svg-icons/faMobile'
import {faMapMarker} from '@fortawesome/free-solid-svg-icons/faMapMarker'
import {faPaypal} from '@fortawesome/free-brands-svg-icons/faPaypal'
import {faSignOut} from '@fortawesome/pro-solid-svg-icons/faSignOut'
import {faCaretDown} from '@fortawesome/free-solid-svg-icons/faCaretDown'
import {faMoneyCheckAlt} from '@fortawesome/free-solid-svg-icons/faMoneyCheckAlt'
import {faRocketLaunch} from '@fortawesome/pro-solid-svg-icons/faRocketLaunch'

library.add(faExpandAlt, faQuestionCircle, faCog, faImage, faFile, faProjectDiagram, faAngleLeft,
  faAngleRight, faCopy, faPlus, faPencilAlt, faTrashAlt, faCode, faVideo, faCalendarAlt,
  faPalette, faSearch, faTimes, faThLarge, faUser, faTimesSolid, faCheck, faSort, faBars, faStar,
  faSortDown, faSortUp, faImage, faEye, faBell, faArrowToBottom, faEnvelope, faMobile, faMapMarker,
  faCompressAlt, faPaypal, faSignOut, faCaretDown, faArrowLeft, faArrowRight, faMoneyCheckAlt,
  faRocketLaunch, fasArrowRight)

dom.watch()



// WEBPACK FOOTER //
// ./src/scripts/_fontawesome.js